import { render, staticRenderFns } from "./HostEvent.vue?vue&type=template&id=5a314396&scoped=true&"
import script from "./HostEvent.vue?vue&type=script&lang=js&"
export * from "./HostEvent.vue?vue&type=script&lang=js&"
import style0 from "./HostEvent.vue?vue&type=style&index=0&id=5a314396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a314396",
  null
  
)

export default component.exports